const GraphQLQuery = require('app/graphql/Query');

class StatsTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'seller': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.seller = this.settings.seller;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    buildTab(){
	}
}

module.exports = StatsTab;

